module.exports = __webpack_public_path__ + "img/wral-color.50cab32.svg";